/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IPresetPathsNode {
       [key : number] : string[];
    }

    export class PresetPathsNode implements IPresetPathsNode {

        [key : number] : string[];

        public static Empty(): PresetPathsNode {
            return new PresetPathsNode();
        }

        constructor() {
            // empty constructor
        }

    }
}